export default __webpack_public_path__ + "static/media/BgBlue.633cc6c6.png";